import MainButton from "../../../../shared/button/MainButton";
import styles from "./AcceptReferalModal.module.scss";
import GlobalModalComponent from "../../../../shared/globalModal/GlobalModalComponent";
import close from "../../../../../assets/images/referal/Close Icon.svg";
import { useEffect, useState } from "react";
import { ReferalServices } from "../../../../../services/referal.service";
import Spinner from "../../../../shared/spinner/Spinner";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";
interface props {
  showExtraModal: boolean;
  setShowExtraModal: (value: boolean) => void;
}

const AcceptReferalModal = ({ showExtraModal, setShowExtraModal }: props) => {
  const [requestList, setRequestList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const { data } = useSelector((state: RootState) => state.translationData);

  useEffect(() => {
    setRefresh(false);
    setLoading(true);
    ReferalServices.referalRequestList()
      .then((response) => setRequestList(response.data.original))
      .catch(() => console.log("err"))
      .finally(() => setLoading(false));
  }, [refresh]);

  const hanldeAccept = (id: number) => {
    ReferalServices.acceptRequest(id)
      .then(() => {
        toast.success(data?.application_accepted);
      })
      .catch(() => {
        toast.error(data?.error_occurred);
      });
    setRefresh(true);
  };
  const handleReject = (id: number) => {
    ReferalServices.rececjRequest(id)
      .then(() => {
        toast.success(data?.application_deleted);
      })
      .catch(() => {
        toast.error(data?.error_occurred);
      });
    setRefresh(true);
  };

  return (
    <GlobalModalComponent
      isOpen={showExtraModal}
      onClose={() => setShowExtraModal(false)}
    >
      <div
        className={styles.close_icon}
        onClick={() => setShowExtraModal(false)}
      >
        <img src={close} alt="x" />
      </div>
      <div className={styles.current_acc_modal}>
        {loading ? (
          <Spinner />
        ) : requestList?.length !== 0 ? (
          requestList?.map(
            (el: { id: number; name: string; surname: string }) => {
              return (
                <div className={styles.moda_contenntl}>
                  <h3 className={styles.title}>{`${el.name} ${el.surname}`}</h3>
                  <p className={styles.subtitle}>
                    {/* Hesabınıza daxil olmağa icazə verirsiniz? */}
                    {data?.auth_common_allow_login}
                  </p>
                  <div className={styles.form}>
                    <MainButton
                      onClick={() => handleReject(el.id)}
                      className={styles.buttonOrange}
                      text={data?.auth_common_delete}
                    />
                    <MainButton
                      onClick={() => hanldeAccept(el.id)}
                      text={data?.auth_common_accept}
                    />
                  </div>
                </div>
              );
            }
          )
        ) : (
          <div className={styles.no_request}>
            <p>{data?.auth_referal_no_requests}</p>
          </div>
        )}
      </div>
    </GlobalModalComponent>
  );
};

export default AcceptReferalModal;
